import { DEFAULT_CURRENCY, DEFAULT_LOCALE } from '@/const/quote'
import { isEmptyString } from './string'

export const formatCurrency = (val, decimal = 2) => {
  return val
    .toLocaleString(DEFAULT_LOCALE, {
      style: 'currency',
      currency: DEFAULT_CURRENCY,
      minimumFractionDigits: decimal,
      maximumFractionDigits: decimal,
    })
    .replace('$', '$ ')
}

export const toTitleCase = str => {
  return str.replace(
    /^[a-z]|[A-Z]/g,
    (c, i) => (i ? ' ' : '') + c.toUpperCase(),
  )
}

export const capitalize = str => {
  if (isEmptyString(str)) return ''

  return `${str[0].toUpperCase()}${str.substring(1, str.length).toLowerCase()}`
}

export const formatPostcode = postcode => {
  return `${postcode.toString().length < 4 ? '0' : ''}${postcode}`
}

export const formatExpiryMonth = month => {
  return month < 10 ? `0${month}` : month.toString()
}

export const formatTicketAddress = ticket => {
  if (!ticket.address_1) {
    return ticket.location_description ?? ''
  }

  const lines = [ticket.address_1]

  if (ticket.address_2 && ticket.address_2 !== '') {
    lines.push(ticket.address_2)
  }
  // A missing city used to be pushed anyway, so the address read "..., undefined
  // 0629" and any geocoder given that string answers with something else
  // entirely. The postcode gets the same treatment for the same reason.
  if (ticket.city && '' !== ticket.city) {
    lines.push(ticket.city)
  }

  const postcode = ticket.postcode ? ` ${ticket.postcode}` : ''

  return `${lines.join(', ')}${postcode}`
}

export const numberFormat = (value, options) => {
  return new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    ...options,
  }).format(value)
}

export const financialNumberFormat = value => {
  return Number.parseFloat(value).toFixed(2)
}

export const formatUrl = url => {
  if (url.startsWith('http')) return url

  return `https://${url}`
}

export const formatQuoteStatus = status => {
  return status.replace('_', ' ')
}
